import { useEffect } from 'react'
import Cookies from 'universal-cookie'
import { initializeApollo } from './apolloClient'
import {
  CREATE_GOOGLE_CLICK_ID,
  CREATE_FACEBOOK_CLICK_ID,
} from '@/graphql/index'

type ClickIdType = 'gclid' | 'fbclid'

export const useClickId = (types: ClickIdType[] = ['gclid', 'fbclid']) => {
  useEffect(() => {
    if (window?.location?.search) {
      const params = new URLSearchParams(window.location.search)
      const cookies = new Cookies()

      types.forEach((type) => {
        const id = params.get(type)
        if (id) {
          cookies.set(type, id, {
            path: '/',
            maxAge: 60 * 60 * 24 * 90, // 90 days
          })
        }
      })
    }
  }, [types])
}

export const getClickId = (type: ClickIdType) => {
  const cookies = new Cookies()
  const id = cookies.get(type)
  return id || null
}

export const saveGoogleClickId = async (result) => {
  const googleClickId = getClickId('gclid')
  if (googleClickId) {
    const apolloClient = initializeApollo()
    const { data } = await apolloClient.mutate({
      mutation: CREATE_GOOGLE_CLICK_ID,
      variables: {
        googleClickId: {
          clickId: googleClickId,
          appId: result?.createDogApplication?.id,
          isPaid: false,
        },
      },
    })
    return data
  }
}

export const saveFacebookClickId = async (result) => {
  const facebookClickId = getClickId('fbclid')
  if (facebookClickId) {
    const apolloClient = initializeApollo()
    const { data } = await apolloClient.mutate({
      mutation: CREATE_FACEBOOK_CLICK_ID,
      variables: {
        facebookClickId: {
          clickId: facebookClickId,
          appId: result?.createDogApplication?.id,
          isPaid: false,
        },
      },
    })
    return data
  }
}
